import React, { useState } from "react";
import MinusButton from "../../../../components/MinusButton";
import { toast } from "../../../../components/toastNotification";
const AttachmentModalMainEdit = ({
  setOldAttachments,
  setNewAttachments,
  setForDeleteAttachments,
  oldAttachments,
  newAttachments,
  forDeleteAttachments = [],
}) => {
  const [attachmentDisplay, setAttachmentDisplay] = useState<any>();

  const removeFile = (file) => {
    if (
      oldAttachments.filter(
        (fname: any) => fname.sourceLink === file.sourceLink
      )
    ) {
      setForDeleteAttachments([...forDeleteAttachments, file]);
      setOldAttachments(
        oldAttachments.filter(
          (fname: any) => fname.sourceLink !== file.sourceLink
        )
      );
    }

    if (file.sourceLink === newAttachments?.name) {
      setNewAttachments();
      setAttachmentDisplay(undefined);
    }
  };

  return (
    <>
      <div className="text-xs">
        <div className="bg-LightWhite flex flex-col text-xs mt-2 divide-y">
          {attachmentDisplay && (
            <div className="flex justify-between px-2 py-1">
              <div className="font-semibold text-left text-primary pr-2">
                {attachmentDisplay?.sourceLink}
              </div>
              <div className="flex items-center">
                <MinusButton
                  onClick={() => {
                    removeFile(attachmentDisplay);
                  }}
                />
              </div>
            </div>
          )}
          {newAttachments === undefined
            ? oldAttachments.length > 0 &&
              oldAttachments?.map((file: any, i) => {
                return (
                  <div key={i} className="flex justify-between px-2 py-1">
                    <div
                      className="font-semibold text-left text-primary pr-2"
                      hidden={newAttachments !== undefined}
                    >
                      {file?.sourceLink}
                    </div>
                    <div className="flex items-center">
                      <MinusButton
                        onClick={() => {
                          removeFile(file);
                        }}
                      />
                    </div>
                  </div>
                );
              })
            : ""}
        </div>
        <div className="flex justify-center pt-2">
          <label
            className="w-1/2 text-center bg-primary text-white
                   py-1 px-1 border font-medium rounded-full cursor-pointer hover:bg-white hover:text-primary hover:border-primary"
          >
            <input
              type="file"
              className="hidden"
              onChange={(e) => {
                if (e.target.files && e.target.files.length > 0) {
                  const newFile = e.target.files[0] && e.target.files[0];
                  const forUploadFiles = new FormData();
                  forUploadFiles.append("file", e.target.files[0]);
                  var reader = new FileReader();
                  reader.readAsDataURL(e.target.files[0]);
                  reader.onload = () => {
                    const fileName = e.target.files && e.target.files[0].name;
                    var rowIndex = oldAttachments.findIndex(
                      (obj: any) => obj.sourceLink === fileName
                    );
                    if (rowIndex < 0) {
                      setAttachmentDisplay({
                        sourceLink: fileName,
                      });
                      setNewAttachments(newFile);
                    } else {
                      toast.fire(
                        "Attachment failed",
                        "File already exist",
                        "error"
                      );
                    }
                  };
                }
              }}
            />
            Choose File
          </label>
        </div>
      </div>
    </>
  );
};

export default AttachmentModalMainEdit;
